import { Directive, ElementRef, HostListener, Renderer2, Input, inject } from '@angular/core';

@Directive( {
    selector: '[appScrollwithme]',
    standalone: false
} )
export class HisScrollwithmeDirective {
    el = inject(ElementRef);
    private renderer = inject(Renderer2);

    reached = false;
    initElPosition: number;

    @Input( 'appScrollwithme' ) keepSize: string;

    @HostListener( 'window:scroll' )
    onWindowScroll() {
    	const parent = this.el.nativeElement.parentNode;
    	const element = this.el.nativeElement;

    	// Überprüfe, ob das Parent-Element bereits die Klasse enthält
    	if (!parent.classList.contains('scrollwithmeWrapper')) {
    	    this.renderer.addClass(parent, 'scrollwithmeWrapper');
    	    // Position des Elternelements initial setzen
    	    if (parent.offsetTop > 0) {
    	        this.initElPosition = parent.offsetTop;
    	    }
    	}

    	// Position prüfen, ob oberen Fensterrand erreicht
    	const scrollPosition = window.pageYOffset;
    	this.reached = scrollPosition >= this.initElPosition;

    	// Zoomlevel prüfen, um scrollWithMe-active bei > 300% Zoom auszublenden
    	if (this.checkZoom(300)) {
    	    if (element.classList.contains('scrollWithMe-active')) {
    	        this.renderer.removeClass(element, 'scrollWithMe-active');
    	        this.renderer.removeStyle(parent, 'padding-top');
    	        this.renderer.removeStyle(element, 'left');
    	        this.renderer.removeStyle(element, 'max-width');
    	    }
    	    return;
    	}

    	// Wenn das Elternelement den oberen Fensterrand erreicht und Zoom-Level passt
    	if (this.initElPosition >= 1 && this.initElPosition !== undefined && this.reached) {
    	    // Höhe des Elternelements setzen, um das Springen des Browsers zu verhindern,
    	    // falls es noch nicht angedockt ist
    	    if (!element.classList.contains('scrollWithMe-active')) {
    	        const elHeight = element.offsetHeight;
    	        const elLeft = element.getBoundingClientRect().left;

    	        // Breite setzen, wenn keepSize gewählt ist
    	        if (this.keepSize === 'keepSize') {
    	            const elWidth = element.offsetWidth;
    	            this.renderer.setStyle(element, 'max-width', elWidth + 'px');
    	        } else {
    	            const newWidth = window.innerWidth - elLeft - 30;
    	            this.renderer.setStyle(element, 'max-width', newWidth + 'px');
    	        }

    	        // Höhe des Wraps setzen, um das Springen des Browsers zu verhindern und die Position von links
    	        this.renderer.setStyle(parent, 'padding-top', elHeight + 'px');
    	        this.renderer.setStyle(element, 'left', elLeft + 'px');
    	        this.renderer.addClass(element, 'scrollWithMe-active');
    	    }
    	} else {
    	    // Reset styles and remove class if not reached or conditions change
    	    this.renderer.removeStyle(parent, 'padding-top');
    	    this.renderer.removeStyle(element, 'left');
    	    this.renderer.removeStyle(element, 'max-width');
    	    this.renderer.removeClass(element, 'scrollWithMe-active');
    	}
    }
    
    checkZoom(zoomLevel: number) {
      	let browserZoom = window.devicePixelRatio * 100;
      	return browserZoom >= zoomLevel ? true : false;
    }
}
